import type { ReactNode } from "react";
import { Sparkles } from "lucide-react";

interface AuthShellProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}

export function AuthShell({ title, subtitle, children, footer }: AuthShellProps) {
  return (
    <div className="relative flex min-h-full flex-col bg-slate-50 overflow-hidden">

      {/* Decorative premium background blobs */}
      <div className="absolute top-[-20%] left-[-10%] h-[600px] w-[600px] rounded-full bg-brand-200/25 blur-3xl" />
      <div className="absolute bottom-[-10%] right-[-15%] h-[500px] w-[500px] rounded-full bg-indigo-200/20 blur-3xl" />

      <div className="relative flex flex-1 items-center justify-center px-4 sm:px-6 py-16 z-10">
        <div className="w-full max-w-[420px] animate-scale-in">

          {/* Logo & Header branding */}
          <div className="mb-8 flex flex-col items-center justify-center gap-2">
            <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-linear-to-tr from-brand-600 to-brand-500 text-white shadow-lg shadow-brand-500/20">
              <Sparkles className="h-6 w-6" />
            </div>
            <span className="text-xl font-extrabold tracking-tight text-slate-900 mt-2">Triage</span>
            <span className="text-xs font-semibold text-slate-400">AI-Powered Support Operator</span>
          </div>

          {/* Form Card */}
          <div className="rounded-3xl border border-slate-200/60 bg-white p-8 shadow-[0_8px_32px_rgba(0,0,0,0.03)]">
            <h1 className="text-xl font-bold tracking-tight text-slate-950">{title}</h1>
            {subtitle && <p className="mt-1.5 text-sm text-slate-500 leading-normal">{subtitle}</p>}
            <div className="mt-7">{children}</div>
          </div>

          {/* Footer Navigation Link */}
          {footer && <div className="mt-6 text-center text-sm text-slate-500">{footer}</div>}
        </div>
      </div>

      <div className="relative py-6 text-center text-[11px] font-semibold text-slate-400 z-10 border-t border-slate-100">
        © 2026 APPGAMBiT. AI inbox operator for ops & support teams.
      </div>
    </div>
  );
}
